<template>
  <v-layout row>
    <v-flex xs12 sm10 offset-sm1 lg10 offset-lg1>
          <div class="container-form px-3 py-3">
            <v-card flat class="container-form-inner mb-3">
              <v-card-title>
                <h2 class="font-weight-regular">Datos Personales</h2>
              </v-card-title>
              <v-card-text>
                <v-layout row wrap mt-2>
                  <v-flex xs12 lg4 px-1>
                    <v-text-field
                      :form="form"
                      label="Nombre completo"
                      :v-errors="errors"
                      v-model="form.name"
                      name="name"
                      v-validate="'required'"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg4 px-1>
                    <v-text-field
                      :form="form"
                      label="Celular"
                      :v-errors="errors"
                      v-model="form.cellphone"
                      name="cellphone"
                      v-validate="'required'"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg4 px-1>
                    <v-text-field
                      :form="form"
                      label="Email"
                      :v-errors="errors"
                      v-model="form.email"
                      name="email"
                      type="email"
                      v-validate="'required|email'"
                      readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card flat class="container-form-inner mb-3">
              <v-card-title>
                <h2 class="font-weight-regular">Usted es?</h2>
              </v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 lg3 px-1>
                    <v-checkbox
                      v-model="form.recommendation_is"
                      label="Egresado"
                      value="Egresado"
                      color="primary"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12 lg3 px-1 v-if="form.recommendation_is.includes('Egresado')">
                    <text-input
                      :form="form"
                      label="Año de Egresado"
                      :v-errors="errors"
                      v-model="form.graduate_year"
                      name="graduate_year"
                      v-validate="'required'"
                    ></text-input>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 lg3 px-1>
                    <v-checkbox
                      v-model="form.recommendation_is"
                      label="Exalumno"
                      value="Exalumno"
                      color="primary"
                    >
                    </v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 lg3 px-1>
                    <v-checkbox
                    v-model="form.recommendation_is"
                      label="Papá del colegio"
                      value="Papa del colegio"
                      color="primary"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12 lg3 px-1 v-if="form.recommendation_is.includes('Papa del colegio')">
                    <text-input
                      :form="form"
                      label="Hijo"
                      :v-errors="errors"
                      v-model="form.child_name"
                      name="child_name"
                      v-validate="'required'"
                    ></text-input>
                  </v-flex>
                  <v-flex xs12 lg3 px-1 v-if="form.recommendation_is.includes('Papa del colegio')">
                    <text-input
                      :form="form"
                      label="Grado"
                      :v-errors="errors"
                      v-model="form.child_grade"
                      name="child_grade"
                      v-validate="'required'"
                    ></text-input>
                  </v-flex>
                  <v-flex xs12 lg3 px-1 v-if="form.recommendation_is.includes('Papa del colegio')">
                    <text-input
                      :form="form"
                      label="Código de familia"
                      :v-errors="errors"
                      v-model="form.recomendation_family"
                      name="recomendation_family"
                      v-validate="'required'"
                    ></text-input>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 lg3 px-1>
                    <v-checkbox
                      v-model="form.recommendation_is"
                      label="Papá de un exalumno"
                      value="Papa de un exalumno"
                      color="primary"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12 lg3 px-1 v-if="form.recommendation_is.includes('Papa de un exalumno')">
                    <text-input
                      :form="form"
                      label="Hijo"
                      :v-errors="errors"
                      v-model="form.ex_name"
                      name="ex_name"
                      v-validate="'required'"
                    ></text-input>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 lg3 px-1>
                    <v-checkbox
                      v-model="form.recommendation_is"
                      label="Familia pasiva"
                      value="Familia pasiva"
                      color="primary"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12 lg3 px-1 v-if="form.recommendation_is.includes('Familia pasiva')">
                    <text-input
                      :form="form"
                      label="Hijo"
                      :v-errors="errors"
                      v-model="form.passive_name"
                      name="passive_name"
                      v-validate="'required'"
                    ></text-input>
                  </v-flex>
                  <v-flex xs12 lg3 px-1 v-if="form.recommendation_is.includes('Familia pasiva')">
                    <text-input
                      :form="form"
                      label="Año en que ingresará"
                      :v-errors="errors"
                      v-model="form.child_year"
                      name="child_year"
                      v-validate="'required'"
                    ></text-input>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 lg3 px-1>
                    <v-checkbox
                      v-model="form.recommendation_is"
                      label="Otro"
                      value="Otro"
                      color="primary"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12 lg6 px-1 v-if="form.recommendation_is.includes('Otro')">
                    <text-input
                      :form="form"
                      label="Escriba aquí"
                      :v-errors="errors"
                      v-model="form.other_text"
                      name="other_text"
                      v-validate="'required'"
                    ></text-input>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card flat class="container-form-inner mb-3">
              <v-card-title>
                <h2 class="font-weight-regular">Sobre la Familia</h2>
              </v-card-title>
              <v-card-text>
                <v-layout row wrap mt-2>
                  <v-flex xs12 lg4 px-1>
                    <v-select
                      :form="form"
                      label="Acudiente"
                      :items="responsible"
                      :v-errors="errors"
                      name="guardian"
                      v-model="form.guardian"
                      @change="selectParent($event)"
                      v-validate="'required'"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 lg4 px-1>
                    <select-input
                      :form="form"
                      label="Hace cuanto lo conoce"
                      :items="years"
                      :v-errors="errors"
                      v-model="form.known_how_long"
                      name="known_how_long"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                  <v-flex xs12 lg4 px-1>
                    <select-input
                      :form="form"
                      label="Tipo de Relación"
                      :items="relation_options"
                      :v-errors="errors"
                      name="relation"
                      v-model="form.relation"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                  <v-flex xs12 lg6 px-1>
                    <select-input
                      :form="form"
                      label="En una escala de 1 a 10, ¿qué tanto conoce al acudiente?"
                      :items="one_ten"
                      :v-errors="errors"
                      v-model="form.know_how_much"
                      name="know_how_much"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card flat class="container-form-inner mb-3">
              <v-card-title>
                <h2 class="font-weight-regular">Confirmación Laboral del Acudiente</h2>
              </v-card-title>
              <v-card-text>
                <v-layout row wrap mt-2>
                  <v-flex xs12 lg4 px-1>
                    <select-input
                      :form="form"
                      label="La siguiente información es correcta"
                      :items="options"
                      :v-errors="errors"
                      name="correct_info"
                      v-model="form.correct_info"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                  <v-flex xs12 lg4 px-1>
                    <v-text-field
                      :form="form"
                      label="Ocupación"
                      :v-errors="errors"
                      v-model="ocupation"
                      name="ocupation"
                      v-validate="'required'"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg4 px-1>
                    <v-text-field
                      :form="form"
                      label="Empleador"
                      :v-errors="errors"
                      v-model="company"
                      name="company"
                      v-validate="'required'"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg12 px-1>
                    <text-area-input
                      :form="form"
                      label="Información adicional del acudiente"
                      :v-errors="errors"
                      v-model="form.guardian_info"
                      name="guardian_info"
                      v-validate="'required'"
                    ></text-area-input>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card flat class="container-form-inner mb-3">
              <v-card-title>
                <h2 class="font-weight-regular">Preguntas</h2>
              </v-card-title>
              <v-card-text>
                <v-layout row wrap mt-2>
                  <v-flex xs12 lg12 px-1>
                    <select-input
                      :form="form"
                      label="¿Usted se sentiría tranquilo si el hijo(a) de la familia a la que está recomendando más adelante forma parte de su familia?"
                      :items="questions_options"
                      :v-errors="errors"
                      name="part_family"
                      v-model="form.part_family"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                  <v-flex xs12 lg12 px-1>
                    <select-input
                      :form="form"
                      label="¿Usted permitiría que sus hijos fueran de vacaciones con la familia que está recomendando?"
                      :items="questions_options"
                      :v-errors="errors"
                      name="vacation_family"
                      v-model="form.vacation_family"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                  <v-flex xs12 lg12 px-1>
                    <select-input
                      :form="form"
                      label="¿La familia a la que está recomendando, participa en actividades que son legal y socialmente aceptadas?"
                      :items="questions_options"
                      :v-errors="errors"
                      name="legal_activities"
                      v-model="form.legal_activities"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                  <v-flex xs12 lg12 px-1>
                    <select-input
                      :form="form"
                      label="¿Cree usted que la familia que recomienda puede asumir cumplidamente las obligaciones económicas?"
                      :items="questions_options"
                      :v-errors="errors"
                      name="economic_obligations"
                      v-model="form.economic_obligations"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                  <v-flex xs12 lg12 px-1>
                    <select-input
                      :form="form"
                      label="¿Conoce de alguna situación de carácter penal de alguno de los miembros de la familia aspirante y su entorno cercano?"
                      :items="questions_options"
                      :v-errors="errors"
                      name="criminal_situation"
                      v-model="form.criminal_situation"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                  <v-flex xs12 lg12 px-1>
                    <select-input
                      :form="form"
                      label="¿Tiene usted alguna razón para considerar que esta familia no debería hacer parte de la comunidad de The Columbus School?"
                      :items="questions_options"
                      :v-errors="errors"
                      name="not_columbus"
                      v-model="form.not_columbus"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                  <v-flex xs12 lg12 px-1>
                    <select-input
                      :form="form"
                      label="La familia aspirante a la que recomienda, ¿tiene familiares en el Colegio?"
                      :items="questions_options"
                      :v-errors="errors"
                      name="family_relatives"
                      v-model="form.family_relatives"
                      v-validate="'required'"
                    ></select-input>
                  </v-flex>
                  <v-flex xs12 lg12 px-1 v-if="form.family_relatives === 'Si'">
                    <text-area-input
                      :form="form"
                      label="Escriba los nombres de los familiares, la relación que tienen con el aspirante y grado en el que se encuentra matriculado el familiar."
                      :v-errors="errors"
                      v-model="form.info_relatives"
                      name="info_relatives"
                      v-validate="'required'"
                    ></text-area-input>
                  </v-flex>
                  <v-flex xs12 lg12 px-1>
                    <text-area-input
                      :form="form"
                      label="Use este espacio si desea agregar información sobre aspectos relevantes de la familia que está recomendando."
                      :v-errors="errors"
                      v-model="form.family_info"
                      name="family_info"
                      v-validate="'required'"
                    ></text-area-input>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card>
              <progress-bar :show="form.busy"></progress-bar>
              <form @submit.prevent="sendForm" @keydown="form.onKeydown($event)" id="admissions-form">

                <v-card-actions class="px-4 pb-4">
                  <v-btn
                    form="admissions-form"
                    type="submit"
                    color="primary"
                  >{{$t('save')}}</v-btn>
                </v-card-actions>
              </form>
            </v-card>
          </div>
    </v-flex>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="490">
        <v-card>
          <v-card-title class="headline success white--text">{{$t('register_ok')}}</v-card-title>
          <v-card-text>
            {{$t('register_ok')}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">{{$t('extracurriculares.courses.form.cancel')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'
import axios from 'axios'
import moment from 'moment';
import FileUpload from 'vue-upload-component'

export default {
  name: 'register-view',
  components: {
    FileUpload,
  },
  metaInfo () {
    return { title: 'Formulario de Recomendaciones' }
  },

  data () {
    return {
      appUrl: window.config.appUrl,
      dialog: false,
      dialogVerifyEmail: false,
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 50 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      form: new Form({
        name: '',
        cellphone: '',
        email: '',
        recommendation_is: [],
        guardian: '',
        known_how_long: '',
        relation: '',
        know_how_much: '',
        correct_info: '',
        graduate_year: '',
        child_name: '',
        ex_name: '',
        passive_name: '',
        child_grade: '',
        recomendation_family: '',
        child_year: '',
        other_text: '',
        guardian_info: '',
        part_family: '',
        vacation_family: '',
        legal_activities: '',
        economic_obligations: '',
        criminal_situation: '',
        not_columbus: '',
        family_relatives: '',
        info_relatives: '',
        family_info: ''
      }),
      formVerification: new Form({
        code: '',
      }),
      eye: true,
      nit_types: [
        { value: 'CC', text: 'Cedula de ciudadania' },
        { value: 'CE', text: 'Cedula de extranjeria' },

      ],
      locales: [
        { value: 'en', text: 'EN' },
        { value: 'es', text: 'ES' }
      ],
      countries: [],
      states: [],
      cities: [],
      options: [
        {value: 'Si', text: this.$t('admissions.form.yesno_options.yes')},
        {value: 'No', text: this.$t('admissions.form.yesno_options.no')}
      ],
      questions_options: [
        {value: 'Si', text: this.$t('admissions.form.yesno_options.yes')},
        {value: 'No', text: this.$t('admissions.form.yesno_options.no')},
        {value: 'No está seguro', text: 'No está seguro'}
      ],
      kinship_options: [
        {value: 'Padre', text: this.$t('admissions.form.kinship_options.father')},
        {value: 'Madre', text: this.$t('admissions.form.kinship_options.mother')},
        {value: 'Abuelo', text: this.$t('admissions.form.kinship_options.grandfather')},
        {value: 'Abuela', text: this.$t('admissions.form.kinship_options.grandmother')},
        {value: 'Tío', text: this.$t('admissions.form.kinship_options.uncle')},
        {value: 'Tía', text: this.$t('admissions.form.kinship_options.aunt')},
        {value: 'Hermano', text: this.$t('admissions.form.kinship_options.brother')},
        {value: 'Hermana', text: this.$t('admissions.form.kinship_options.sister')},
        {value: 'Otro', text: this.$t('admissions.form.kinship_options.other')}
      ],
      relation_options: [
        {value: 'Personal', text: 'Personal'},
        {value: 'Laboral', text: 'Laboral'}
      ],
      document_options: [
        {value: 'CC', text: 'Cédula de Ciudadanía'},
        {value: 'PA', text: 'Pasaporte'},
        {value: 'CE', text: 'Cédula de Extranjería'},
        {value: 'VI', text: 'Visa'}
      ],
      religion_options: [
        {value: 'Católica', text: 'Católica'},
        {value: 'Protestante', text: 'Protestante'},
        {value: 'Musulmana', text: 'Musulmana'},
        {value: 'Ninguna', text: 'Ninguna'}
      ],
      nationality_options: [
        {value: 'Colombiana', text: 'Colombiana'},
        {value: 'Americana', text: 'Americana'},
        {value: 'Argentina', text: 'Argentina'},
        {value: 'Colombo-Portuguesa', text: 'Colombo-Portuguesa'}
      ],
      responsible: [
        {value: 'Acudiente 1', text: 'Acudiente 1'},
        {value: 'Acudiente 2', text: 'Acudiente 2'},
        {value: 'Otro', text: 'Otro'}
      ],
      one_ten: [
        {value: '1', text: '1'},
        {value: '2', text: '2'},
        {value: '3', text: '3'},
        {value: '4', text: '4'},
        {value: '5', text: '5'},
        {value: '6', text: '6'},
        {value: '7', text: '7'},
        {value: '8', text: '8'},
        {value: '9', text: '9'},
        {value: '10', text: '10'}
      ],
      years: [
        {value: '1 año', text: '1 año'},
        {value: '2 años', text: '2 años'},
        {value: '3 años', text: '3 años'},
        {value: '4 años', text: '4 años'},
        {value: '5 años', text: '5 años'},
        {value: '6 años', text: '6 años'},
        {value: '7 años', text: '7 años'},
        {value: '8 años', text: '8 años'},
        {value: '9 años', text: '9 años'},
        {value: '10 años o más', text: '10 años o más'}
      ],
      ocupation: "",
      company: "",
      recommendation: [],
      meetings: [],
      settings: [],
      family: [],
      disabled1: true,
      disabled2: true,
      disabled_date: false,
      verification_code: '',
      verification_target: '',
      confirm_code: '',
      registro_civil: [],
      registro_civil_twin: [],
      token: this.$route.params.token,
      addressDialog: false
    }
  },

  created () {
    this.form.locale = this.locale;
    this.init()
  },

  computed: {
    ...mapGetters({
      locale: 'locale'
    }),
    statesToShow() {
      return this.states.filter(state => state.id_pais === this.form.country)
    },
    citiesToShow() {
      return this.cities.filter(city => city.id_departamento === this.form.state)
    },
  },

  watch: {
    locale(newValue, oldValue) {
      this.form.locale = newValue
    },
  },

  methods: {
      init() {
        this.token = this.$route.params.token
        axios.get(`/api/admissions/recommendation/${this.token}`)
          .then(resp => {
            if (resp.status === 200) {
              this.recommendation = resp.data[0],
              this.form = new Form({
                id: resp.data[0].id,
                name: resp.data[0].name,
                cellphone: resp.data[0].cellphone,
                email: resp.data[0].email,
                recommendation_is: [],
                guardian: '',
                known_how_long: '',
                relation: '',
                know_how_much: '',
                correct_info: '',
                graduate_year: '',
                child_name: '',
                ex_name: '',
                passive_name: '',
                child_grade: '',
                recomendation_family: '',
                child_year: '',
                other_text: '',
                guardian_info: '',
                part_family: '',
                vacation_family: '',
                legal_activities: '',
                economic_obligations: '',
                criminal_situation: '',
                not_columbus: '',
                family_relatives: '',
                info_relatives: '',
                family_info: '',
                submitted: 1
              })
              this.responsible = [
                {value: 'guardian1', text: resp.data[0].guardian1_first_name + " " + resp.data[0].guardian1_last_name},
                {value: 'guardian2', text: resp.data[0].guardian2_first_name + " " + resp.data[0].guardian2_last_name}
              ]
            }
          })
      },
    showAddressDialog() {
      this.addressDialog = true
    },
    close() {
      this.dialog = false
      this.dialogVerifyEmail = false
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    selectParent(value) {
      if (value == 'guardian1') {
        this.ocupation = this.recommendation.guardian1_ocupation
        this.company = this.recommendation.guardian1_company
      } else {
        this.ocupation = this.recommendation.guardian2_ocupation
        this.company = this.recommendation.guardian2_company
      }
    },
    async sendForm () {
      console.log(JSON.stringify(this.errors))
      if (await this.formHasErrors()) return

      // Register the user.
      this.form.put('/api/admissions/recommendation')
        .then(resp => {
            if (resp.data.already_submitted) {
              this.$store.dispatch('responseMessage', {
                  type: 'warning',
                  text: 'Ya se ha enviado esta recomendación',
                  modal: true
              })
            } else  {
              this.$store.dispatch('responseMessage', {
                  type: 'success',
                  text: 'Recomendación enviada correctamente',
                  modal: true
              })
            }
        })
        .catch(err => {
          console.log(err.response)
        })
    },
  }
}
</script>

<style lang="scss" scoped>
  .container-form{
    background: #6198c8;
    border-radius: 16px;
    box-shadow: -6px 6px 6px #0000001A;
  }
  .container-form-inner{
    background: #F2F2F2;
    border-radius: 30px;
  }
  .container-form-inner .v-card__title, .v-expansion-panel__header .v-card__title{
    color: #004990;
    justify-content: center;
    background: #FFF;
  }
  .upload-picture {
    border-radius: 50%;
    background: #FFF;
    box-shadow: 0px 3px 6px #00000029;
    text-align: center;
    aspect-ratio: 1 / 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .example-btn .v-btn {
    font-weight: lighter;
    line-height: 38px;
    width: 38px;
    height: 38px;
    font-size: 30px;
    border-radius: 50%;
    min-width: auto;
    padding: 0;
  }
  .v-expansion-panel {
    box-shadow: none;
  }
  .theme--light.v-expansion-panel .v-expansion-panel__container {
    background-color: transparent;
  }
  .v-expansion-panel__header {
    background: #FFF;
    border-radius: 30px 30px 0 0;
  }
  .bg-transparent {
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/recommendation-form.vue